;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('addressDisplay', AddressDisplayDirective)

  AddressDisplayDirective.$inject = []

  function AddressDisplayDirective () {
    return {
      restrict: 'E',
      bindToController: true,
      controller: function () {
        var self = this
        if (!self.entity) return

        self.entity.populate && self.entity.populate('defaultAddress')
        self.type = self.entity.__t

        /**
         * Trying everything possible to return the country
         * @param  {Object} address - object
         * @return {String}
         */
        self.notInFrance = function (address) {
          return !address || !address.country || address.country.toLowerCase() !== 'france'
        }

        /**
         * Add prefix to lodgement
         * @param  {Object} address element
         * @return {String} the address
         */
        self.getLodgement = function (address) {
          if (!address) {
            return
          }
          var properties = [
            { label: 'Bat.', key: 'building' },
            { label: 'Eta.', key: 'floor' },
            { label: 'App.', key: 'apartment' },
            { label: 'Dig.', key: 'intercom' },
            { label: 'Esc.', key: 'stairs' },
            { label: 'Porte', key: 'door' }
          ]

          /**
           * For every property above, create the string, appending the correct label and value.
           * If we have more than 3 elements, add a <br> every 3 elements
           */
          var string = _.reduce(properties, function (result, prop, k) {
            if (address[ prop.key ]) {
              result += prop.label + ' ' +
                address[ prop.key ] +
                ((k % 3 === 2) ? '<br>' : ' - ')
            }
            return result
          }, '')
          return string
        }
      },

      templateUrl: '/app/common/directives/address-display/address-display.html',
      controllerAs: 'addressdisplay',
      scope: {
        'entity': '=',
        'hideIcon': '='
      }
    }
  }
})(window.angular)
